(function () {
  if (window.tjmAnnouncement) return;
  window.tjmAnnouncement = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (!root || root.getAttribute('data-tjm-announcement-ready') === 'true') return;

    var viewport = root.querySelector('[data-tjm-announcement-viewport]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-tjm-announcement-slide]'));
    var prev = root.querySelector('[data-tjm-announcement-prev]');
    var next = root.querySelector('[data-tjm-announcement-next]');
    var status = root.querySelector('[data-tjm-announcement-status]');

    if (!viewport || slides.length === 0) return;

    root.setAttribute('data-tjm-announcement-ready', 'true');

    var autoplaySetting = root.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-speed'), 10);
    if (!speed || speed < 1000) speed = 5000;

    var index = 0;
    var timer = null;
    var pointerInside = false;
    var focusInside = false;
    var editorHold = false;

    slides.forEach(function (slide, slideIndex) {
      if (slide.classList.contains('is-active')) index = slideIndex;
    });

    function syncPause() {
      pointerInside = root.matches(':hover');
      focusInside = root.contains(document.activeElement);
    }

    function canAutoplay() {
      syncPause();
      return autoplaySetting && slides.length > 1 && !reduceMotion.matches && !pointerInside && !focusInside && !editorHold;
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (!canAutoplay()) return;
      timer = window.setInterval(function () {
        if (!canAutoplay()) {
          stop();
          return;
        }
        show(index + 1, false);
      }, speed);
    }

    function layout(behavior) {
      var width = viewport.clientWidth;
      if (!width) return;
      slides.forEach(function (slide) {
        slide.style.flexBasis = width + 'px';
        slide.style.width = width + 'px';
      });
      viewport.scrollTo({
        left: index * width,
        behavior: behavior,
      });
    }

    function show(nextIndex, announce) {
      var count = slides.length;
      index = ((nextIndex % count) + count) % count;

      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) {
          slide.removeAttribute('inert');
        } else {
          slide.setAttribute('inert', '');
        }
      });

      layout(reduceMotion.matches ? 'auto' : 'smooth');

      if (announce && status) {
        var activeSlide = slides[index];
        status.textContent = activeSlide ? activeSlide.textContent.trim() : '';
      }
    }

    function go(delta) {
      show(index + delta, true);
      start();
    }

    function onPrev() {
      go(-1);
    }

    function onNext() {
      go(1);
    }

    function onKeydown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        go(-1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        go(1);
      }
    }

    function onResize() {
      layout('auto');
    }

    function onMotionChange() {
      layout('auto');
      start();
    }

    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);
    root.addEventListener('keydown', onKeydown);
    root.addEventListener('mouseenter', function () {
      pointerInside = true;
      stop();
    });
    root.addEventListener('mouseleave', function () {
      pointerInside = false;
      start();
    });
    root.addEventListener('focusin', function () {
      focusInside = true;
      stop();
    });
    root.addEventListener('focusout', function () {
      window.setTimeout(function () {
        focusInside = root.contains(document.activeElement);
        if (focusInside) stop();
        else start();
      }, 0);
    });
    window.addEventListener('resize', onResize);
    if (typeof reduceMotion.addEventListener === 'function') {
      reduceMotion.addEventListener('change', onMotionChange);
    }

    root._tjmAnnouncement = {
      select: function (slide) {
        var selected = slides.indexOf(slide);
        if (selected < 0) return;
        editorHold = true;
        stop();
        show(selected, false);
      },
      release: function () {
        editorHold = false;
        start();
      },
      destroy: function () {
        stop();
        window.removeEventListener('resize', onResize);
        if (typeof reduceMotion.removeEventListener === 'function') {
          reduceMotion.removeEventListener('change', onMotionChange);
        }
        root._tjmAnnouncement = null;
      },
    };

    show(index, false);
    start();
  }

  function boot(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll('[data-tjm-announcement]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-tjm-announcement]');
    if (root && root._tjmAnnouncement) root._tjmAnnouncement.destroy();
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.closest('[data-tjm-announcement-slide]');
    if (!slide) return;
    var root = slide.closest('[data-tjm-announcement]');
    if (root && root._tjmAnnouncement) root._tjmAnnouncement.select(slide);
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var slide = event.target.closest('[data-tjm-announcement-slide]');
    if (!slide) return;
    var root = slide.closest('[data-tjm-announcement]');
    if (root && root._tjmAnnouncement) root._tjmAnnouncement.release();
  });
})();
